module.exports = __webpack_public_path__ + "static/media/lmHow-It-works_ownthedata.5f150b31.png";